import { thunk } from 'redux-thunk'
import { createStore, applyMiddleware } from 'redux'

import rootReducer from './index'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension'

const persistConfig = {
  key: 'root',
  storage: storage,
  stateReconciler: autoMergeLevel2,
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

export default function configureStore() {
  const middleware = [thunk]
  let store = createStore(
    persistedReducer,
    composeWithDevToolsDevelopmentOnly(applyMiddleware(...middleware)),
  )
  let persistor = persistStore(store)
  return { store, persistor }
}
